import { useState, useEffect } from "react";
import { getBookingList , getKundaliServ} from "../../services/appointment.service";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
function UserDetails() {
  const navigate =useNavigate()
  const params = useParams()
  const [showSkelton, setShowSkelton] = useState(false);
  const [details, setDetails] = useState([]);
  const handleGetKundaliDetails = async () => {
    setShowSkelton(true);
    try {
      let response = await getKundaliServ(params.id);
      if (response?.data?.success) {
        setDetails(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetKundaliDetails();
  }, []);
  return (
    <>
      <div className="kundali-details-container">
        <div className="container" style={{position:"relative",top:"50px", marginBottom:"-50px"}}>
        <h1 onClick={()=>navigate("/user-management")} className="text-light d-flex justify-content-center align-items-center" style={{height:"45px", borderRadius:"50%", width:"45px", background:"#FDD99D"}}>
          <i className="fa fa-arrow-left text-dark" style={{fontSize:"20px"}}></i>
        </h1>
        </div>
      
        <div
          className="container d-flex align-items-center justify-content-center  py-4"
          style={{
            padding: "20px 30px",
            color: "#E1C699",
          }}
        >
          
          
          <div className="d-flex flex-column">
            <img src="/images/brandLogo.png" className="brandLogo img-fluid" style={{height:"110px"}} />
          </div>
        </div>
        
        <div className="container my-4 p-4  border-white user-card-data ">
          {showSkelton ? <div className="row">
            <div className="col-lg-6 col-md-12" >
              <div className="blackInputBox p-4 ">
                <p>Name</p>
                <Skeleton width="100%" height={40} />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Date Of Birth</p>
                <Skeleton width="100%" height={40} />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Birth Time</p>
                <Skeleton width="100%" height={40} />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Birth Place </p>
                <Skeleton width="100%" height={40} />
              </div>
            </div>
          </div>:<div className="row">
            <div className="col-lg-6 col-md-12" >
              <div className="blackInputBox p-4 ">
                <p>Name</p>
                <h3>{details?.name}</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Date Of Birth</p>
                <h3>{details?.dob}</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Birth Time</p>
                <h3>{details?.birthTime}</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="blackInputBox p-4">
                <p>Birth Place </p>
                <h3>{details?.birthLocation}</h3>
              </div>
            </div>
          </div>}
          
          <div className="d-flex justify-content-center">

          <button className="kundaliSbmitBtn mt-5" onClick={()=>alert("Coming Soon")}>Submit Details</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserDetails;
